"use client";

const Pagination = ({ t }) => {
  // const goToPage = (currentPage) => {
  //   return onChange(currentPage);
  // };

  return (
    <div className="pagination">
      <div className="pagination">
        <button
          // onClick={() => goToPage(page - 1)}
          // disabled={page === 1}
          className="page-btn prevBtn"
        >
          {t["button.prev"]}
        </button>

        {/* {[...Array(Math.ceil(total / per_page))].map((_, index) => ( */}
        <button
          // key={index}
          // onClick={() => goToPage(index + 1)}
          // className={`page-btn ${page === index + 1 ? "active" : ""}`}
          className="page-btn"
        >
          {/* {index + 1} */}1
        </button>
        <button
          // key={index}
          // onClick={() => goToPage(index + 1)}
          // className={`page-btn ${page === index + 1 ? "active" : ""}`}
          className="page-btn active"
        >
          {/* {index + 1} */}1
        </button>
        {/* ))} */}

        <button
          // onClick={() => goToPage(page + 1)}
          // disabled={page === last_page}
          className="page-btn nextBtn"
        >
          {t["button.next"]}
        </button>
      </div>
    </div>
  );
};

export default Pagination;
